// const synth = window.speechSynthesis // 启用文本
// const msg = new SpeechSynthesisUtterance()

// export function handleSpeak(text) {
//     msg.text = text // 内容
//     msg.lang = 'zh-CN' // 使用的语言:中文
//     msg.volume = 1 // 声音音量：1
//     msg.rate = 1 // 语速：1
//     msg.pitch = 1 // 音高：1
//     synth.speak(msg) // 播放
// }


export function ding() {
    let audio = new Audio(require('@/assets/audio/ding.mp3'));
    audio.play();
}